export const CALENDLY_URL_US = "https://calendly.com/olrf/application-consultation";

export const CALENDLY_URL_YEAR_11 = "https://calendly.com/olrf-uk/year-11-admission-call";
export const CALENDLY_URL_YEAR_13 = "https://calendly.com/olrf-uk/year-13-admission-call";
export const CALENDLY_URL_IB = "https://calendly.com/olrf-uk/international-baccalaureate-interview";
export const CALENDLY_URL_SEN = "https://calendly.com/olrf-uk/kih-safeguarding";
